import axios from "../../../axios/axiosSetup";
import { BASE_URL } from "../../../configs/WebServiceUrl";

const LMS_BASE = `${BASE_URL}/lms`;

// ---- Classes ----
export const lmsGetClasses = () =>
  axios.get(`${LMS_BASE}/classes`);

export const lmsCreateClass = (data) =>
  axios.post(`${LMS_BASE}/classes`, data);

export const lmsUpdateClass = (id, data) =>
  axios.put(`${LMS_BASE}/classes/${id}`, data);

export const lmsDeleteClass = (id) =>
  axios.delete(`${LMS_BASE}/classes/${id}`);

// ---- School Classes ----
export const lmsGetSchoolClasses = (schoolId) =>
  axios.get(`${LMS_BASE}/school-classes`, { params: { school_id: schoolId } });

export const lmsCreateSchoolClass = (data) =>
  axios.post(`${LMS_BASE}/school-classes`, data);

export const lmsDeleteSchoolClass = (id) =>
  axios.delete(`${LMS_BASE}/school-classes/${id}`);

// ---- Subjects ----
export const lmsGetSubjects = (schoolId) =>
  axios.get(`${LMS_BASE}/subjects`, { params: { school_id: schoolId } });

export const lmsCreateSubject = (data) =>
  axios.post(`${LMS_BASE}/subjects`, data);

export const lmsUpdateSubject = (id, data) =>
  axios.put(`${LMS_BASE}/subjects/${id}`, data);

export const lmsDeleteSubject = (id) =>
  axios.delete(`${LMS_BASE}/subjects/${id}`);

// ---- Class Subjects ----
export const lmsGetClassSubjects = (params) =>
  axios.get(`${LMS_BASE}/class-subjects`, { params });

export const lmsCreateClassSubject = (data) =>
  axios.post(`${LMS_BASE}/class-subjects`, data);

export const lmsDeleteClassSubject = (id) =>
  axios.delete(`${LMS_BASE}/class-subjects/${id}`);

// ---- Chapters ----
export const lmsGetChapters = (params) =>
  axios.get(`${LMS_BASE}/chapters`, { params });

export const lmsCreateChapter = (data) =>
  axios.post(`${LMS_BASE}/chapters`, data);

export const lmsUpdateChapter = (id, data) =>
  axios.put(`${LMS_BASE}/chapters/${id}`, data);

export const lmsDeleteChapter = (id) =>
  axios.delete(`${LMS_BASE}/chapters/${id}`);

// ---- Topics ----
export const lmsGetTopics = (params) =>
  axios.get(`${LMS_BASE}/topics`, { params });

export const lmsCreateTopic = (data) =>
  axios.post(`${LMS_BASE}/topics`, data);

export const lmsUpdateTopic = (id, data) =>
  axios.put(`${LMS_BASE}/topics/${id}`, data);

export const lmsDeleteTopic = (id) =>
  axios.delete(`${LMS_BASE}/topics/${id}`);

// ---- Study Materials ----
export const lmsGetMaterials = (params) =>
  axios.get(`${LMS_BASE}/study-materials`, { params });

export const lmsUploadMaterial = (formData) =>
  axios.post(`${LMS_BASE}/study-materials/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const lmsAddVideoUrl = (data) =>
  axios.post(`${LMS_BASE}/study-materials/video-url`, data);

export const lmsUpdateMaterial = (id, data) =>
  axios.put(`${LMS_BASE}/study-materials/${id}`, data);

export const lmsDeleteMaterial = (id) =>
  axios.delete(`${LMS_BASE}/study-materials/${id}`);

// ---- Courses ----
export const lmsGetCourses = (params) =>
  axios.get(`${LMS_BASE}/courses`, { params });

export const lmsGetCoursesByClassId = (classId, schoolId) =>
  axios.get(`${LMS_BASE}/courses/class/${classId}`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetCoursesByClassAndStudentId = (classId, studentId, schoolId) =>
  axios.get(`${LMS_BASE}/enrollments/class/${classId}/student/${studentId}`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetCourseById = (id) =>
  axios.get(`${LMS_BASE}/courses/${id}`);

export const lmsUploadCourseThumbnail = (file) => {
  const fd = new FormData();
  fd.append("thumbnail", file);
  return axios.post(`${LMS_BASE}/courses/thumbnail`, fd);
};

export const lmsCreateCourse = (data) =>
  axios.post(`${LMS_BASE}/courses`, data);

export const lmsUpdateCourse = (id, data) =>
  axios.put(`${LMS_BASE}/courses/${id}`, data);

export const lmsDeleteCourse = (id) =>
  axios.delete(`${LMS_BASE}/courses/${id}`);

// ---- Teachers ----
export const lmsGetTeachers = (params) =>
  axios.get(`${LMS_BASE}/teachers`, { params });

export const lmsGetTeacherById = (id) =>
  axios.get(`${LMS_BASE}/teachers/${id}`);

export const lmsCreateTeacher = (formData) =>
  axios.post(`${LMS_BASE}/teachers`, formData, { headers: { "Content-Type": "multipart/form-data" } });

export const lmsUpdateTeacher = (id, formData) =>
  axios.put(`${LMS_BASE}/teachers/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });

export const lmsDeleteTeacher = (id) =>
  axios.delete(`${LMS_BASE}/teachers/${id}`);

export const lmsGetTeacherClassSubjects = (teacherId) =>
  axios.get(`${LMS_BASE}/teachers/${teacherId}/class-subjects`);

export const lmsAssignTeacherClassSubject = (teacherId, data) =>
  axios.post(`${LMS_BASE}/teachers/${teacherId}/class-subjects`, data);

export const lmsRemoveTeacherClassSubject = (teacherId, csId) =>
  axios.delete(`${LMS_BASE}/teachers/${teacherId}/class-subjects/${csId}`);

// ---- Course Teachers ----
export const lmsGetCourseTeachers = (courseId) =>
  axios.get(`${LMS_BASE}/courses/${courseId}/teachers`);

export const lmsAssignCourseTeacher = (courseId, data) =>
  axios.post(`${LMS_BASE}/courses/${courseId}/teachers`, data);

export const lmsRemoveCourseTeacher = (courseId, teacherId) =>
  axios.delete(`${LMS_BASE}/courses/${courseId}/teachers/${teacherId}`);

export const lmsGetCourseMaterials = (courseId) =>
  axios.get(`${LMS_BASE}/courses/${courseId}/materials`);

// ---- Students ----
export const lmsGetStudents = (params) =>
  axios.get(`${LMS_BASE}/students`, { params });

export const lmsCreateStudent = (formData) => {
  if (formData instanceof FormData) {
    return axios.post(`${LMS_BASE}/students`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  return axios.post(`${LMS_BASE}/students`, formData);
};

export const lmsUpdateStudent = (id, formData) => {
  if (formData instanceof FormData) {
    return axios.put(`${LMS_BASE}/students/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  return axios.put(`${LMS_BASE}/students/${id}`, formData);
};

export const lmsDeleteStudent = (id) =>
  axios.delete(`${LMS_BASE}/students/${id}`);

// ---- Enrollments & Payments ----
export const lmsCreateEnrollments = (data) => {
  if (data instanceof FormData) {
    return axios.post(`${LMS_BASE}/enrollments`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  return axios.post(`${LMS_BASE}/enrollments`, data);
};

export const lmsSubmitStudentCourseRequest = (data) => {
  if (data instanceof FormData) {
    return axios.post(`${LMS_BASE}/enrollments/student-request`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  return axios.post(`${LMS_BASE}/enrollments/student-request`, data);
};

export const lmsApproveStudentCourseRequest = (enrollmentId, data) =>
  axios.put(`${LMS_BASE}/enrollments/${enrollmentId}/approve`, data);

export const lmsRejectStudentCourseRequest = (enrollmentId, data) =>
  axios.put(`${LMS_BASE}/enrollments/${enrollmentId}/reject`, data);

export const lmsGetEnrollmentsByStudentId = (studentId, schoolId) =>
  axios.get(`${LMS_BASE}/enrollments/student/${studentId}`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

// ---- Exams ----
export const lmsGetExams = (params) =>
  axios.get(`${LMS_BASE}/exams`, { params });

export const lmsGetExamById = (id) =>
  axios.get(`${LMS_BASE}/exams/${id}`);

export const lmsCreateExam = (data) =>
  axios.post(`${LMS_BASE}/exams`, data);

export const lmsUpdateExam = (id, data) =>
  axios.put(`${LMS_BASE}/exams/${id}`, data);

export const lmsDeleteExam = (id) =>
  axios.delete(`${LMS_BASE}/exams/${id}`);

// ---- Question Papers (PDF) ----
export const lmsGetQuestionPapers = (params) =>
  axios.get(`${LMS_BASE}/question-papers`, { params });

export const lmsUploadQuestionPaper = (formData) =>
  axios.post(`${LMS_BASE}/question-papers/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const lmsUpdateQuestionPaper = (id, data) =>
  axios.put(`${LMS_BASE}/question-papers/${id}`, data);

export const lmsDeleteQuestionPaper = (id) =>
  axios.delete(`${LMS_BASE}/question-papers/${id}`);

// ---- Answer Sheets ----
export const lmsGetAnswerSheets = (params) =>
  axios.get(`${LMS_BASE}/answer-sheets`, { params });

export const lmsUploadAnswerSheet = (formData) =>
  axios.post(`${LMS_BASE}/answer-sheets/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const lmsReviewAnswerSheet = (id, data) =>
  axios.put(`${LMS_BASE}/answer-sheets/${id}/review`, data);

export const lmsDeleteAnswerSheet = (id) =>
  axios.delete(`${LMS_BASE}/answer-sheets/${id}`);

// ---- Manual Question Papers ----
export const lmsGetManualPapers = (params) =>
  axios.get(`${LMS_BASE}/manual-papers`, { params });

export const lmsGetManualPaperById = (id) =>
  axios.get(`${LMS_BASE}/manual-papers/${id}`);

export const lmsCreateManualPaper = (data) =>
  axios.post(`${LMS_BASE}/manual-papers`, data);

export const lmsUpdateManualPaper = (id, data) =>
  axios.put(`${LMS_BASE}/manual-papers/${id}`, data);

export const lmsDeleteManualPaper = (id) =>
  axios.delete(`${LMS_BASE}/manual-papers/${id}`);

// Sections
export const lmsCreateSection = (paperId, data) =>
  axios.post(`${LMS_BASE}/manual-papers/${paperId}/sections`, data);

export const lmsUpdateSection = (id, data) =>
  axios.put(`${LMS_BASE}/manual-papers/sections/${id}`, data);

export const lmsDeleteSection = (id) =>
  axios.delete(`${LMS_BASE}/manual-papers/sections/${id}`);

// Questions
export const lmsCreateQuestion = (sectionId, data) =>
  axios.post(`${LMS_BASE}/manual-papers/sections/${sectionId}/questions`, data);

export const lmsUpdateQuestion = (id, data) =>
  axios.put(`${LMS_BASE}/manual-papers/questions/${id}`, data);

export const lmsDeleteQuestion = (id) =>
  axios.delete(`${LMS_BASE}/manual-papers/questions/${id}`);

// Options
export const lmsUpdateOption = (id, data) =>
  axios.put(`${LMS_BASE}/manual-papers/options/${id}`, data);

// ---- Live Classes (BigBlueButton) ----
export const lmsGetLiveClasses = (params) =>
  axios.get(`${LMS_BASE}/live-classes`, { params });

export const lmsGetLiveClassById = (id) =>
  axios.get(`${LMS_BASE}/live-classes/${id}`);

export const lmsCreateLiveClass = (data) =>
  axios.post(`${LMS_BASE}/live-classes`, data);

export const lmsUpdateLiveClass = (id, data) =>
  axios.put(`${LMS_BASE}/live-classes/${id}`, data);

export const lmsDeleteLiveClass = (id) =>
  axios.delete(`${LMS_BASE}/live-classes/${id}`);

export const lmsGetLiveClassJoinUrl = (id, params) =>
  axios.get(`${LMS_BASE}/live-classes/${id}/join`, { params });

export const lmsGetLiveClassStatus = (id) =>
  axios.get(`${LMS_BASE}/live-classes/${id}/status`);

export const lmsGetLiveClassRecordings = (id) =>
  axios.get(`${LMS_BASE}/live-classes/${id}/recordings`);
export const lmsGetStudentPaymentHistory = (studentId, schoolId) =>
  axios.get(`${LMS_BASE}/enrollments/student/${studentId}/payments`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetStudentCourseRequests = (studentId, schoolId) =>
  axios.get(`${LMS_BASE}/enrollments/student/${studentId}/course-requests`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetStudentEnrolledCourses = (studentId, schoolId) =>
  axios.get(`${LMS_BASE}/students/${studentId}/enrolled-courses`, {
    params: schoolId ? { school_id: schoolId } : {},
  });

export const lmsGetStudentAllCourses = (studentId, schoolId, classId) =>
  axios.get(`${LMS_BASE}/students/${studentId}/all-courses`, {
    params: {
      ...(schoolId ? { school_id: schoolId } : {}),
      ...(classId ? { class_id: classId } : {}),
    },
  });

// ---- Payment Configuration ----
export const lmsGetPaymentConfigBySchoolId = (schoolId) =>
  axios.get(`${LMS_BASE}/payment-config/school/${schoolId}`);

export const lmsGetPaymentConfigs = (params) =>
  axios.get(`${LMS_BASE}/payment-config`, { params });

export const lmsSavePaymentConfig = (data) =>
  axios.post(`${LMS_BASE}/payment-config`, data);

export const lmsUpdatePaymentConfig = (id, data) =>
  axios.put(`${LMS_BASE}/payment-config/${id}`, data);

export const lmsDeletePaymentConfig = (id) =>
  axios.delete(`${LMS_BASE}/payment-config/${id}`);
